<script>
    import { onDestroy } from 'svelte';
    import { v4 as uuidv4 } from 'uuid';
    import { db, timeStamp, arrayUnion } from '../../firebase/firebase.config.js';

    // Custom Methods
    // import currentMonth from '../../Methods/currentMonth.js';
    import {handleFunds, validateData} from '../../methods/handleFunds.js';
    
    // Custom Components

    // Stores
    import {BankStore, UserStore} from '../../store';

    
    let uid;
    let bankData;

    // Input field's values Variables
    let fundsFormData = {
        fundsAmount: undefined,
        fundsProvider: undefined,
        selectedBank: undefined,
        fundsDate: undefined
    };
    let validationProps = {  
        amountEmpty: false,
        providerEmpty: false,
        bankEmpty: false,
        dateEmpty: false
    };


    // Stores
    const unsubUserStore = UserStore.subscribe(data => {
        uid = data.uid;
    });



    //Methods

    const callHandleFunds = () => {

        
        validateData(fundsFormData)
            .then(response => {
                validationProps = {  
                    amountEmpty: false,
                    providerEmpty: false,
                    bankEmpty: false,
                    dateEmpty: false
                };
                if (response.validation) {
                    handleFunds(fundsFormData, uid, BankStore)
                    .then(response => {
                        if (response.dataSaved) {
                            fundsFormData = {
                                fundsAmount: undefined,
                                fundsProvider: undefined,
                                selectedBank: undefined,
                                fundsDate: undefined
                            };
                        }
                    });
                }
            })
            .catch((err) => {
                validationProps = {  
                    amountEmpty: false,
                    providerEmpty: false,
                    bankEmpty: false,
                    dateEmpty: false
                };
                console.log(err);
                validationProps[`${err.field}`] = true;
                console.log('err = ', err.msg, '', err.field, validationProps[`${err.field}`]);
            });
        
    };

    
    // Life-cycle Hooks

    onDestroy(() => {
        unsubUserStore();
    });
</script>




<div class="modal-content bg-light">

    <!-- Header -->
    <div class="modal-header border-0">
        <h5 class="modal-title text-secondary">Add Funds</h5>
        <button type="button" class="close text-dark" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <!-- Body -->
    <div class="modal-body">

        <!-- Add Funds - Form -->
        <form>
            <div class="form-row">

                <!-- Funds Amount - Input -->
                <div class="form-group col-12 col-md">
                    <label for="expenseAmount">Funds Amount</label>
                    <input type="number" class="form-control" class:is-invalid={validationProps.amountEmpty} id="expenseAmount" aria-describedby="Expense Amount" placeholder="Enter the amount." bind:value={fundsFormData.fundsAmount}>
                    <div class="invalid-feedback" class:d-none={!validationProps.amountEmpty}>Funds Amount is Required</div>
                </div>

                <!-- Banks - Radio Btns -->
                <div class="form-group col-12 col-md">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <label class="mb-0" for="expenseCatagory">Banks</label>
                        <button type="button" class="btn p-0">
                            <svg width="1.25em" height="1.25em" viewBox="0 0 16 16" class="bi bi-plus-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </button>
                    </div>
                    <div class="custom-control custom-radio" class:is-invalid={validationProps.bankEmpty}>
                        <input type="radio" id="monthlyBank" name="bankRadio" class="custom-control-input" class:is-invalid={validationProps.bankEmpty} bind:group={fundsFormData.selectedBank} value="monthlyBank" required>
                        <label class="custom-control-label" class:is-invalid={validationProps.bankEmpty} for="monthlyBank">Monthly Bank</label>
                    </div>
                    <div class="custom-control custom-radio" class:is-invalid={validationProps.bankEmpty}>
                        <input type="radio" id="reserveBank" name="bankRadio" class="custom-control-input" class:is-invalid={validationProps.bankEmpty} bind:group={fundsFormData.selectedBank} value="reserveBank" required>
                        <label class="custom-control-label" class:is-invalid={validationProps.bankEmpty} for="reserveBank">Reserve Bank</label>
                    </div>
                    <div class="invalid-feedback" class:d-none={!validationProps.bankEmpty}>Bank is Required</div>
                </div>

            </div>

            <div class="form-row flex-column">
                <!-- Funds From - Select -->
                <div class="form-group col-12 col-md-6 pr-2">
                    <label for="expenseCatagory">Funds From</label>
                    <select class="custom-select" class:is-invalid={validationProps.providerEmpty} id="expenseCatagory" bind:value={fundsFormData.fundsProvider}>
                        <option value={undefined} selected>Select funds provider</option>
                        <option value="Tallal">Tallal</option>
                        <option value="Bilal">Bilal</option>
                        <option value="Maa Jee">Maa Jee</option>
                    </select>
                    <div class="invalid-feedback" class:d-none={!validationProps.providerEmpty}>Must select who provided funds.</div>
                </div>

                <!-- Date - Select -->
                <div class="form-group col-12 col-md-6 pr-2">
                    <label for="expenseDate">Date</label>
                    <input type="date" class="form-control" class:is-invalid={validationProps.dateEmpty} id="expenseDate" bind:value={fundsFormData.fundsDate}>
                    <div class="invalid-feedback" class:d-none={!validationProps.dateEmpty}>Date is Required</div>
                </div>
            </div>
        </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer border-0">
        <button type="button" class="btn btn-dark" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-secondary" on:click={callHandleFunds}>Save changes</button>
    </div>

</div>